import { styled } from "@linaria/react";
import React, { type FC, useState } from "react";
import type { ButtonBasicProps } from "@/components/buttons/shared.ts";
import { t } from "@/themes/theme.ts";

const ButtonGenericStyle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 25px;
  width: 100%;

  font-family: ${t.fontPrimary};
  font-size: var(--14px);

  padding: 8px 16px;

  border: none;
  cursor: pointer;

  border-radius: ${t.buttonBorderRadius};

  transition:
    background-color 0.3s,
    scale 0.5s
      linear(
        0,
        1.114 8.5%,
        1.37 12.9%,
        1.315 16.2%,
        0.941 24%,
        0.869 27.8%,
        0.882 30.7%,
        1.012 38.3%,
        1.046 42.7%,
        0.984,
        1.006 72.2%,
        1
      );

  background-color: var(--background-color);
  color: var(--text-color);

  &:disabled {
    background-color: var(--disabled-background-color);
    color: var(--disabled-text-color);
    scale: 95%;
    cursor: wait;
  }

  &[data-flare="true"] {
    &:hover {
      scale: 105%;
    }

    &:active {
      scale: 95%;
    }

    &:disabled {
      scale: 1;
    }
  }
`;

interface ButtonProps extends ButtonBasicProps {
  text: string;
  backgroundColor?: string;
  disabledBackgroundColor?: string;
  textColor?: string;
  disabledTextColor?: string;
  padding?: string;
  border?: string;
}

export const ButtonGeneric: FC<ButtonProps> = ({
  text,
  backgroundColor,
  disabledBackgroundColor,
  textColor,
  disabledTextColor,
  onClick,
  padding,
  border,
  flare,
}) => {
  const [disabled, setDisabled] = useState(false);

  return (
    <ButtonGenericStyle
      onClick={() => {
        if (disabled || !onClick) return;

        setDisabled(true);

        const finished = () => {
          setDisabled(false);
        };

        onClick(finished);
      }}
      style={
        {
          "--background-color": backgroundColor ?? "none",
          "--text-color": textColor ?? "white",
          "--disabled-background-color": disabledBackgroundColor ?? backgroundColor ?? "none",
          "--disabled-text-color": disabledTextColor ?? textColor ?? "white",
          padding: padding,
          border: border,
        } as React.CSSProperties
      }
      disabled={disabled}
      data-flare={flare}
    >
      {text}
    </ButtonGenericStyle>
  );
};
